import { Controller } from '@hotwired/stimulus'

export default class CheckAllInputFilledController extends Controller {
  static targets = ['submitButton', 'input'];

  updateSubmitButton(event) {
    event.stopPropagation();

    const allInputsFilled = this.inputTargets.every((input) => input.value.trim() !== '');
    this.submitButtonTarget.toggleAttribute('disabled', !allInputsFilled);
  }
}
